import { Typography, VerticalDivider } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';

import { OrderStatusBadge } from '../../molecules/OrderStatusBadge';

import * as S from './style';

const SubTitle = ({ links, title, status, style }) => {
  return (
    <S.SubTitleWrapper style={style}>
      <S.LeftColumn>
        <Typography variant="body1Bold">{title}</Typography>
        {links && (
          <>
            <VerticalDivider $height={14} />
            {links}
          </>
        )}
      </S.LeftColumn>
      <OrderStatusBadge status={status} />
    </S.SubTitleWrapper>
  );
};

SubTitle.S = S;

SubTitle.propTypes = {
  title: PropTypes.string,
  status: PropTypes.string,
  links: PropTypes.node,
  style: PropTypes.object
};

export { SubTitle };
